import { SignalsSummary } from "@/features/signals";
import { ScanOpportunities } from "@/features/scanner";
import { SimulationPanel } from "@/features/simulation";

export function SignalsPage() {
  return (
    <div className="space-y-4 md:space-y-6">
      <SignalsSummary />
      <ScanOpportunities />
      <SimulationPanel />
    </div>
  );
}
